import { useEffect, useState } from "react";
import { canAccessPage, readStoredUser, USER_STORAGE_EVENT } from "../utils/permissions";
import "../assets/css/sidebar.css";

export default function Sidebar({ collapsed, pinned, onToggleCollapse, onTogglePin, activePath, onNavigate }) {
  const [user, setUser] = useState(() => readStoredUser());

  useEffect(() => {
    const refreshUser = () => setUser(readStoredUser());
    window.addEventListener(USER_STORAGE_EVENT, refreshUser);
    window.addEventListener("storage", refreshUser);
    return () => {
      window.removeEventListener(USER_STORAGE_EVENT, refreshUser);
      window.removeEventListener("storage", refreshUser);
    };
  }, []);
  const items = [
    { label: "Dashboard", to: "/app/dashboard", icon: "DA", pageKey: "dashboard" },
    { label: "Planning", to: "/app/bookings", icon: "PR", pageKey: "booking" },
    { label: "Notifiche", to: "/app/notifications", icon: "NO", pageKey: "" },
    { label: "Ricerca", to: "/app/search", icon: "RI", pageKey: "" },
  ];
  const managementItems = [
    { label: "Servizi", to: "/app/services", icon: "SV", pageKey: "accommodationService" },
    { label: "Soggiorni", to: "/app/booking-accounts", icon: "FA", pageKey: "bookingaccount" },
    { label: "Preventivi", to: "/app/quotes", icon: "PR", pageKey: "quote" },
    { label: "Fatture", to: "/app/free-invoices", icon: "FT", pageKey: "freeInvoice" },
  ];
  const administrationItems = [
    { label: "Clienti", to: "/app/customers", icon: "CL", pageKey: "customer" },
    { label: "Camere", to: "/app/rooms", icon: "CA", pageKey: "room" },
    { label: "Fatturazione", to: "/app/invoicing", icon: "FI", pageKey: "invoicing" },
  ];
  const utilityItems = [
    { label: "Stampe", to: "/app/prints", icon: "ST", pageKey: "prints" },
    { label: "Statistiche", to: "/app/statistics", icon: "SA", pageKey: "statistic" },
    { label: "Redditività", to: "/app/profitability", icon: "RE", pageKey: "profitability" },
  ];
  const configItems = [
    { label: "Azienda", to: "/app/company", icon: "AZ", pageKey: "company" },
    { label: "Utenti", to: "/app/users", icon: "UT", pageKey: "user" },
    { label: "Sedi", to: "/app/sites", icon: "SE", pageKey: "site" },
    { label: "Ruoli", to: "/app/roles", icon: "RU", pageKey: "role" },
    { label: "Tabelle", to: "/app/tables", icon: "TA", pageKey: "table" },
    { label: "Sistema", to: "/app/system", icon: "SI", pageKey: "system" },
  ];
  function canAccessSidebarItem(item) {
    return canAccessPage(user, item.pageKey, 1);
  }

  const visibleItems = items.filter(canAccessSidebarItem);
  const visibleManagementItems = managementItems.filter(canAccessSidebarItem);
  const visibleAdministrationItems = administrationItems.filter(canAccessSidebarItem);
  const visibleUtilityItems = utilityItems.filter(canAccessSidebarItem);
  const visibleConfigItems = configItems.filter(canAccessSidebarItem);

  return (
    <aside className={`sidebar ${collapsed ? "collapsed" : ""}`} role="navigation" aria-label="Sidebar">
      <div className="sidebar_header">
        <button type="button" className="sidebar_iconbtn sidebar_burgerbtn" onClick={onToggleCollapse} aria-label="Apri/chiudi sidebar">
          <span className="sidebar_burger_lines" aria-hidden="true" />
        </button>
        {!collapsed && (
          <div className="sidebar_header_right">
            <div className="sidebar_brand_visual" aria-hidden="true">
              <span className="sidebar_logo_wrt sidebar_logo_wrt_big" />
            </div>
            <button type="button" className={`sidebar_iconbtn sidebar_pinbtn ${pinned ? "on" : ""}`} onClick={onTogglePin} aria-label="Fissa sidebar">
              <span className={`sidebar_pin_svg ${pinned ? "straight" : "tilted"}`} aria-hidden="true" />
            </button>
          </div>
        )}
      </div>
      <nav className="sidebar_nav">
        <div className="sidebar_section">
          {!collapsed && <div className="sidebar_section_title">Generale</div>}
          <div className="sidebar_section_items">
            {visibleItems.map((item) => {
              const active = activePath === item.to || activePath?.startsWith(item.to);
              return (
                <button key={item.to} type="button" className={`sidebar_item ${active ? "active" : ""}`} onClick={() => onNavigate(item.to)} title={item.label}>
                  <span className="sidebar_item_icon">{item.icon}</span>
                  {!collapsed && <span className="sidebar_item_label">{item.label}</span>}
                </button>
              );
            })}
          </div>
        </div>
        <div className="sidebar_section">
          {!collapsed && <div className="sidebar_section_title">Gestione</div>}
          <div className="sidebar_section_items">
            {visibleManagementItems.map((item) => {
              const active = activePath === item.to || activePath?.startsWith(item.to);
              return (
                <button key={item.to} type="button" className={`sidebar_item ${active ? "active" : ""}`} onClick={() => onNavigate(item.to)} title={item.label}>
                  <span className="sidebar_item_icon">{item.icon}</span>
                  {!collapsed && <span className="sidebar_item_label">{item.label}</span>}
                </button>
              );
            })}
          </div>
        </div>

        <div className="sidebar_section">
          {!collapsed && <div className="sidebar_section_title">Amministrazione</div>}
          <div className="sidebar_section_items">
            {visibleAdministrationItems.map((item) => {
              const active = activePath === item.to || activePath?.startsWith(item.to);
              return (
                <button key={item.to} type="button" className={`sidebar_item ${active ? "active" : ""}`} onClick={() => onNavigate(item.to)} title={item.label}>
                  <span className="sidebar_item_icon">{item.icon}</span>
                  {!collapsed && <span className="sidebar_item_label">{item.label}</span>}
                </button>
              );
            })}
          </div>
        </div>

        <div className="sidebar_section">
          {!collapsed && <div className="sidebar_section_title">Utilità</div>}
          <div className="sidebar_section_items">
            {visibleUtilityItems.map((item) => {
              const active = activePath === item.to || activePath?.startsWith(item.to);
              return (
                <button key={item.to} type="button" className={`sidebar_item ${active ? "active" : ""}`} onClick={() => onNavigate(item.to)} title={item.label}>
                  <span className="sidebar_item_icon">{item.icon}</span>
                  {!collapsed && <span className="sidebar_item_label">{item.label}</span>}
                </button>
              );
            })}
          </div>
        </div>
        <div className="sidebar_section">
          {!collapsed && <div className="sidebar_section_title">Configurazioni</div>}
          <div className="sidebar_section_items">
            {visibleConfigItems.map((item) => {
              const active = activePath === item.to || activePath?.startsWith(item.to);
              return (
                <button key={item.to} type="button" className={`sidebar_item ${active ? "active" : ""}`} onClick={() => onNavigate(item.to)} title={item.label}>
                  <span className="sidebar_item_icon">{item.icon}</span>
                  {!collapsed && <span className="sidebar_item_label">{item.label}</span>}
                </button>
              );
            })}
          </div>
        </div>
      </nav>
    </aside>
  );
}
